'use client';

import { Minus, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface QuantitySelectorProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export function QuantitySelector({
  quantity,
  onQuantityChange,
  min = 1,
  max = 99,
  className,
}: QuantitySelectorProps) {
  return (
    <div className={cn('flex items-center gap-0 rounded-xl border border-border bg-muted', className)}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => onQuantityChange(Math.max(min, quantity - 1))}
        disabled={quantity <= min}
        className="rounded-xl text-muted-foreground hover:text-foreground"
      >
        <Minus />
      </Button>
      <span className="flex h-8 w-10 items-center justify-center text-sm font-semibold">
        {quantity}
      </span>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => onQuantityChange(Math.min(max, quantity + 1))}
        disabled={quantity >= max}
        className="rounded-xl text-muted-foreground hover:text-foreground"
      >
        <Plus />
      </Button>
    </div>
  );
}
